import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';
import { MyAccountPayload } from 'api/models/payload';

export function get(customConfig?: AxiosRequestConfig) {
    return client.get('/my_account', customConfig);
}

export function put(
    payload: MyAccountPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.put<{ msg: string }>('/my_account', payload, customConfig);
}
